/* Pale Meridian — shared storefront behaviour */
(function(){
  "use strict";
  document.documentElement.classList.add('js');

  function initAnnounce(){
    var track=document.getElementById('pm-announce-track'); if(!track) return;
    var lines=track.querySelectorAll('.announce__line'), i=0;
    if(lines.length<2) return;
    setInterval(function(){ lines[i].classList.remove('is-on'); i=(i+1)%lines.length; lines[i].classList.add('is-on'); },4800);
  }
  function initDrawer(){
    var drawer=document.getElementById('pm-drawer'), open=document.getElementById('pm-open-drawer');
    if(!drawer||!open) return;
    open.addEventListener('click',function(){drawer.classList.add('is-open');document.body.style.overflow='hidden';});
    drawer.addEventListener('click',function(e){
      if(e.target.hasAttribute('data-close-drawer')||e.target.closest('[data-close-drawer]')){
        drawer.classList.remove('is-open');document.body.style.overflow='';
      }
    });
  }
  function initReveal(){
    var els=[].slice.call(document.querySelectorAll('.reveal'));
    if(!('IntersectionObserver' in window)||!els.length){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);} });
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  function initPDP(){
    // thumbnail switcher (gallery) — variant pill/select logic lives in the PDP section's own inline script
    var thumbs=document.querySelectorAll('.pdp__thumb');
    var main=document.getElementById('pdp-main-img');
    if(thumbs.length){
      thumbs.forEach(function(t){ t.addEventListener('click',function(){
        thumbs.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
        var src=t.getAttribute('data-full'); if(src&&main){ main.src=src; }
        var lbl=t.getAttribute('data-shot'), lblEl=document.getElementById('pdp-main-label');
        if(lbl&&lblEl){ lblEl.textContent=lbl; }
      });});
    }
    // sticky buy bar
    var addBtn=document.getElementById('pm-add-btn'), sticky=document.getElementById('pm-sticky-buy');
    if(addBtn&&sticky&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){
        sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top<0);
      },{threshold:0});
      io.observe(addBtn);
    }
  }
  function boot(){ initAnnounce(); initDrawer(); initReveal(); initPDP(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
